(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[481],{

/***/ 1255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ block_content; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(8863);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ./components/photo.js
var photo = __webpack_require__(727);
// EXTERNAL MODULE: ./components/link.js + 1 modules
var components_link = __webpack_require__(8250);
;// CONCATENATED MODULE: ./components/block-serializers.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var blockSerializers = {
    types: {
        block: function(props) {
            var _node = props.node, markDefs = _node.markDefs, _style = _node.style, style = _style === void 0 ? "normal" : _style;
            // check if our block contains a button
            var hasButton = markDefs && markDefs.some(function(c) {
                return c._type === "link" && c.isButton === true;
            });
            // build our mock header styles
            if (style === "h1mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h1", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h2mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h2", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h3mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h3", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h4mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h4", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h5mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h5", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h6mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h6", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "large") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-lg-3-mobile", "md:text-lg-3", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadLarge") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-large", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadMedium") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-medium", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadSmall") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-small", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "paragraphLarge") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-large font-sansRegular", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "paragraphMedium") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-medium", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "caption") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-caption", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            // go through our remaing, true header styles
            if (/^h\d/.test(style)) {
                return(/*#__PURE__*/ react.createElement(style, {
                    className: hasButton ? "has-btn" : null
                }, props.children));
            }
            // handle all other blocks with the default serializer
            return BlockContent_default().defaultSerializers.types.block(props);
        },
        photo: function(param) {
            var node = param.node;
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                photo: node
            }));
        },
        horizontalRule: function() {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("hr", {});
        }
    },
    marks: {
        link: function(param) {
            var mark = param.mark, children = param.children;
            var title = children[0];
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* default */.Z, {
                link: _objectSpread({}, mark, {
                    title: title
                })
            }));
        }
    }
};

;// CONCATENATED MODULE: ./components/block-content.js





var Content = function(param) {
    var blocks = param.blocks, className = param.className;
    if (!blocks) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
        renderContainerOnSingleChild: true,
        className: classnames_default()("rc", className),
        blocks: blocks,
        serializers: blockSerializers
    }));
};
/* harmony default export */ var block_content = (Content);


/***/ }),

/***/ 9634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(727);




var Media = function(param) {
    var media = param.media, layout = param.layout, _aspect = param.aspect, aspect = _aspect === void 0 ? false : _aspect;
    if (!media) return null;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("media-wrap", {
            "mx-auto": media.maxWidth
        }),
        style: {
            maxWidth: media.maxWidth ? media.maxWidth : "none"
        },
        children: media.photo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            photo: media.photo,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative", {
                "aspect-video": aspect == "video",
                "aspect-square": aspect == "square"
            }),
            width: 2200,
            layout: layout
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Media);


/***/ }),

/***/ 6481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ interactive; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/icon.js
var icon = __webpack_require__(7627);
// EXTERNAL MODULE: ./components/media.js
var components_media = __webpack_require__(9634);
// EXTERNAL MODULE: ./components/phrase.js
var phrase = __webpack_require__(1995);
// EXTERNAL MODULE: ./components/block-content.js + 1 modules
var block_content = __webpack_require__(1255);
// EXTERNAL MODULE: ./lib/context.js + 2 modules
var context = __webpack_require__(2523);
// EXTERNAL MODULE: ./node_modules/react-cool-inview/dist/index.esm.js
var index_esm = __webpack_require__(5276);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(6513);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 27 modules
var motion_minimal = __webpack_require__(6139);
;// CONCATENATED MODULE: ./components/fade-wrap.js





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var FadeWrap = function(_param) {
    var children = _param.children, _offset = _param.offset, offset = _offset === void 0 ? 0 : _offset, _delay = _param.delay, delay = _delay === void 0 ? 0 : _delay, _smallMargin = _param.smallMargin, smallMargin = _smallMargin === void 0 ? false : _smallMargin, rest = _objectWithoutProperties(_param, [
        "children",
        "offset",
        "delay",
        "smallMargin"
    ]);
    var controls = (0,use_animation/* useAnimation */._)();
    var rootMargin =  true ? "".concat(window.outerHeight * -0.4, "px 0px") : 0;
    if (smallMargin) {
        rootMargin = "-50px 0px";
    }
    var ref = (0,index_esm/* default */.ZP)({
        threshold: 0,
        rootMargin: rootMargin,
        onEnter: function(param) {
            var scrollDirection = param.scrollDirection;
            if (scrollDirection.vertical == "up") {
                controls.start("visible");
            }
        }
    }, [
        controls
    ]), observe = ref.observe, inView = ref.inView;
    if (inView) {
        controls.start("visible");
    }
    var defaultVariants = {
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 1,
                delay: delay,
                ease: "easeOut"
            }
        },
        hidden: {
            opacity: 0,
            y: offset,
            transition: {
                duration: 1
            }
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, _objectSpread({
        ref: observe,
        initial: "hidden",
        variants: defaultVariants,
        animate: controls
    }, rest, {
        children: children
    })));
};
/* harmony default export */ var fade_wrap = (FadeWrap);

// EXTERNAL MODULE: ./node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(7005);
;// CONCATENATED MODULE: ./components/modules/interactive.js











var Interactive = function(param1) {
    var _data = param1.data, data = _data === void 0 ? {} : _data;
    var updateSiteTheme = (0,context/* useUpdateSiteTheme */.nc)();
    var style = data.style, backgroundColor = data.backgroundColor, sections = data.sections, reduceMargin = data.reduceMargin, reduceMinHeight = data.reduceMinHeight;
    var foregroundColor = backgroundColor.title == "Slate" ? "white" : "black";
    var ref2 = (0,index_esm/* default */.ZP)({
        threshold: [
            0.2,
            0.4,
            0.6,
            0.8,
            1
        ],
        onEnter: function(param) {
            var scrollDirection = param.scrollDirection;
            if (style !== "longText") {
                updateSiteTheme(backgroundColor.title.toLowerCase());
            }
        },
        onLeave: function(param) {
            var scrollDirection = param.scrollDirection;
            if (style !== "longText") {
                updateSiteTheme(false);
            }
        }
    }), observe = ref2.observe, inView = ref2.inView;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: observe,
        className: classnames_default()("interactive", "grid", "bg-".concat(backgroundColor.value), "text-".concat(foregroundColor), "relative", "style--".concat(style), {
            "pt-[25vh]": style !== "longText" && !reduceMinHeight,
            "mb-[30vh]": style !== "longText" && !reduceMargin
        }),
        "data-bg": backgroundColor.title.toLowerCase(),
        "data-theme": style == "longText" ? backgroundColor.title.toLowerCase() : false,
        children: [
            style == "default" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("interactive-sections"),
                children: sections.map(function(section, idx1) {
                    if (section._type == "gallery") {
                        var ref;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("grid", "grid-cols-4", "md:grid-cols-20"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("col-span-4", "md:col-span-20"),
                                children: section === null || section === void 0 ? void 0 : (ref = section.media) === null || ref === void 0 ? void 0 : ref.map(function(media, idx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                                        media: media,
                                        layout: "intrinsic"
                                    }, idx);
                                })
                            })
                        }, idx1));
                    }
                    if (section._type == "section") {
                        var ref1;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("grid", "grid-cols-4", "md:grid-cols-20", "p-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("col-span-4", "md:col-span-9"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fade_wrap, {
                                        delay: "0.05",
                                        className: "h-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()("sticky-wrap", "md:sticky", "mt-[14px]", "top-0", "align-items-center", "flex", {
                                                "md:h-screen": !reduceMinHeight
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("flex", "md:hidden", "justify-center", "w-full"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(phrase/* default */.Z, {
                                                        phrase: section.phrase + "-",
                                                        typeStyle: "text-subheader-2 uppercase",
                                                        vertical: true,
                                                        dividerMaxWidth: "300px",
                                                        color: backgroundColor.title == "Slate" ? "#ffffff" : "#000000"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("hidden", "md:flex", "w-full"),
                                                    "data-order": "1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(phrase/* default */.Z, {
                                                        phrase: section.phrase + "-",
                                                        phraseMaxWidth: section.phraseMaxWidth ? section.phraseMaxWidth : "none",
                                                        typeStyle: "text-subheader-2 uppercase md:mx-0 md:justify-start",
                                                        vertical: false,
                                                        delay: 0,
                                                        dividerMaxWidth: "1000px",
                                                        color: backgroundColor.title == "Slate" ? "#ffffff" : "#000000"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("col-span-4", "md:col-span-11"),
                                    "data-order": "2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fade_wrap, {
                                        delay: "0.25",
                                        className: classnames_default()({
                                            "md:mt-[50px]": !reduceMinHeight
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()("media-items"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("flex", "items-center"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classnames_default()("w-full", "flex", "items-center", "text-left", "wysiwyg-content", {
                                                            "md:min-h-[100vh] h-full mb-[125px]": !reduceMinHeight
                                                        }),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(block_content/* default */.Z, {
                                                            blocks: section.body
                                                        })
                                                    })
                                                }),
                                                section === null || section === void 0 ? void 0 : (ref1 = section.media) === null || ref1 === void 0 ? void 0 : ref1.map(function(media, idx) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                        className: classnames_default()("flex", "flex-wrap", "items-center", "mb-[10px]", "md:mb-[90px]"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: classnames_default()("w-full"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                                                                    media: media,
                                                                    layout: "intrinsic"
                                                                })
                                                            }),
                                                            idx !== section.media.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: classnames_default()("flex", "md:hidden", "justify-center", "w-full", "mt-[20px]"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(phrase/* default */.Z, {
                                                                    phrase: "-",
                                                                    typeStyle: "text-subheader uppercase",
                                                                    vertical: true,
                                                                    dividerMaxWidth: "300px",
                                                                    color: backgroundColor.title == "Slate" ? "#ffffff" : "#000000"
                                                                })
                                                            })
                                                        ]
                                                    }, idx);
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, idx1));
                    }
                })
            }),
            style == "longText" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("interactive-sections", "md:pb-[125px]", "pt-[125px]", "site-container"),
                children: sections.map(function(section, idx2) {
                    if (section._type == "gallery") {
                        var ref;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("grid", "grid-cols-4", "md:grid-cols-20"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("col-span-4", "md:col-span-20"),
                                children: section === null || section === void 0 ? void 0 : (ref = section.media) === null || ref === void 0 ? void 0 : ref.map(function(media, idx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                                        media: media,
                                        layout: "intrinsic"
                                    }, idx);
                                })
                            })
                        }, idx2));
                    }
                    if (section._type == "section") {
                        var ref3;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("grid", "grid-cols-4", "md:grid-cols-20", "p-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("col-span-4", "md:col-span-5", "md:col-start-3"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("mt-[2px]", "top-0", "align-items-center", "flex", "sticky", "top-[40px]"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()("flex", "md:hidden", "justify-center", "w-full"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(phrase/* default */.Z, {
                                                    phrase: section.phrase + "-",
                                                    phraseMaxWidth: section.phraseMaxWidth ? section.phraseMaxWidth : "none",
                                                    typeStyle: "text-subheader uppercase",
                                                    vertical: true,
                                                    dividerMaxWidth: "50px",
                                                    verticalEndHeight: "50px",
                                                    noAnim: true,
                                                    hideLast: true,
                                                    color: backgroundColor.title == "Slate" ? "#ffffff" : "#000000"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()("hidden", "md:flex", "w-full"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(phrase/* default */.Z, {
                                                    phrase: section.phrase + "-",
                                                    phraseMaxWidth: section.phraseMaxWidth ? section.phraseMaxWidth : "none",
                                                    typeStyle: "text-subheader uppercase md:mx-0 md:justify-start",
                                                    delay: "0",
                                                    vertical: false,
                                                    dividerMaxWidth: "1000px",
                                                    noAnim: true,
                                                    color: backgroundColor.title == "Slate" ? "#ffffff" : "#000000"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("col-span-4", "md:col-span-11"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("media-items"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()("flex", "items-center"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("mb-[40px]", "w-full", "flex", "items-center", "text-left", "md:text-left", "text-large", "mt-[4px]", "md:mt-0", "font-normal", "font-sansRegular", "wysiwyg-content"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(block_content/* default */.Z, {
                                                        blocks: section.body
                                                    })
                                                })
                                            }),
                                            section === null || section === void 0 ? void 0 : (ref3 = section.media) === null || ref3 === void 0 ? void 0 : ref3.map(function(media, idx) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                    className: classnames_default()("flex", "flex-wrap", "items-center", "mb-[10px]"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classnames_default()("w-full"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                                                                media: media,
                                                                layout: "intrinsic"
                                                            })
                                                        }),
                                                        idx !== section.media.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classnames_default()("flex", "md:hidden", "justify-center", "w-full", "mt-[20px]"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(phrase/* default */.Z, {
                                                                phrase: "-",
                                                                typeStyle: "text-subheader uppercase",
                                                                vertical: true,
                                                                dividerMaxWidth: "300px",
                                                                color: backgroundColor.title == "Slate" ? "#ffffff" : "#000000"
                                                            })
                                                        })
                                                    ]
                                                }, idx);
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, idx2));
                    }
                })
            }),
            style == "vertical" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("interactive-sections", "grid", "grid-cols-4", "md:grid-cols-20", "items-center"),
                children: sections.map(function(section, idx3) {
                    var ref;
                    if (section._type == "gallery") {
                        var ref4;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("section-gallery", "col-span-4", "md:col-span-20", "mb-interactive", "relative", "z-30"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                speed: "75",
                                gradient: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("w-full", "aspect-video"),
                                    children: section === null || section === void 0 ? void 0 : (ref4 = section.media) === null || ref4 === void 0 ? void 0 : ref4.map(function(media, idx) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                                            media: media,
                                            layout: "intrinsic"
                                        }, idx);
                                    })
                                })
                            })
                        }, idx3));
                    }
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("col-span-4", "md:col-span-18", "md:col-start-2"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("p-gutter", "md:p-0", "site-container"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(phrase/* default */.Z, {
                                    phrase: section.phrase,
                                    phraseMaxWidth: section.phraseMaxWidth ? section.phraseMaxWidth : "none",
                                    typeStyle: "text-lg-1-mobile md:text-lg-1 text-center",
                                    vertical: true,
                                    dividerMaxWidth: "400px",
                                    customThreshold: [
                                        0.25,
                                        0.75
                                    ],
                                    isStatic: true,
                                    color: backgroundColor.title == "Slate" ? "#ffffff" : "#000000"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()("mb-gutter"),
                                    children: [
                                        section.body && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("mb-10", "wysiwyg-content", "md:max-w-[67%]", "md:mx-auto", "relative", "z-30"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(block_content/* default */.Z, {
                                                blocks: section.body
                                            })
                                        }),
                                        section === null || section === void 0 ? void 0 : (ref = section.media) === null || ref === void 0 ? void 0 : ref.map(function(media, idx) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()("mx-auto"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                                                    media: media,
                                                    layout: "intrinsic"
                                                }, idx)
                                            }, idx);
                                        })
                                    ]
                                }),
                                section.caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("caption", "text-caption", "text-center", "mt-2"),
                                    children: section.caption
                                })
                            ]
                        })
                    }, idx3));
                })
            }),
            style == "cards" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("interactive-sections", "grid", "p-gutter", "grid-cols-4", "sm:grid-cols-20", "items-center"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("col-span-4", "col-start-1", "sm:col-span-18", "sm:col-start-2"),
                    children: sections.map(function(section, idx4) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("flex", "flex-col", "justify-end", {
                                "mb-[50vh]": idx4 !== sections.length - 1
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(phrase/* default */.Z, {
                                    phrase: section.phrase,
                                    phraseMaxWidth: section.phraseMaxWidth ? section.phraseMaxWidth : "none",
                                    typeStyle: "text-lg-1-mobile md:text-lg-1 text-center",
                                    vertical: true,
                                    dividerMaxWidth: "400px",
                                    isStatic: true,
                                    customThreshold: [
                                        0.25,
                                        0.75
                                    ],
                                    color: backgroundColor.title == "Slate" ? "#ffffff" : "#000000"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()("card", "mt-0", "mx-auto", "max-w-[1000px]", "flex", "flex-col", "sm:flex-row", "bg-white", "relative", "z-30", "rounded-[3px]", "p-2", "gap-gutter", "text-black"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("w-full"),
                                            children: section === null || section === void 0 ? void 0 : (ref = section.media) === null || ref === void 0 ? void 0 : ref.map(function(media, idx) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                                                    media: media,
                                                    layout: "static"
                                                }, idx);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()("w-full", "flex", "flex-col"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("text-large", "font-sansRegular", "leading-[24px]", "wysiwyg-content", "mb-20"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(block_content/* default */.Z, {
                                                        blocks: section.body
                                                    })
                                                }),
                                                section.caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("caption", "text-xs", "font-sansRegular", "text-left", "mt-auto"),
                                                    children: section.caption
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, idx4);
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var interactive = (Interactive);


/***/ }),

/***/ 7005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(7294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

___$insertStyle(".marquee-container {\n  overflow-x: hidden !important;\n  display: flex !important;\n  flex-direction: row !important;\n  position: relative;\n  width: 100%;\n}\n.marquee-container:hover div {\n  animation-play-state: var(--pause-on-hover);\n}\n.marquee-container:active div {\n  animation-play-state: var(--pause-on-click);\n}\n\n.overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.overlay::before, .overlay::after {\n  background: linear-gradient(to right, var(--gradient-color));\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: var(--gradient-width);\n  z-index: 2;\n}\n.overlay::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n.overlay::before {\n  left: 0;\n  top: 0;\n}\n\n.marquee {\n  flex: 0 0 auto;\n  min-width: 100%;\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}");

var Marquee = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.style, style = _f === void 0 ? {} : _f, _g = _a.className, className = _g === void 0 ? "" : _g, _h = _a.play, play = _h === void 0 ? true : _h, _j = _a.pauseOnHover, pauseOnHover = _j === void 0 ? false : _j, _k = _a.pauseOnClick, pauseOnClick = _k === void 0 ? false : _k, _l = _a.direction, direction = _l === void 0 ? "left" : _l, _m = _a.speed, speed = _m === void 0 ? 20 : _m, _o = _a.delay, delay = _o === void 0 ? 0 : _o, _p = _a.loop, loop = _p === void 0 ? 0 : _p, _q = _a.gradient, gradient = _q === void 0 ? true : _q, _r = _a.gradientColor, gradientColor = _r === void 0 ? [255, 255, 255] : _r, _s = _a.gradientWidth, gradientWidth = _s === void 0 ? 200 : _s, onFinish = _a.onFinish, onCycleComplete = _a.onCycleComplete, children = _a.children;
    // React Hooks
    var _t = React.useState(0), containerWidth = _t[0], setContainerWidth = _t[1];
    var _u = React.useState(0), marqueeWidth = _u[0], setMarqueeWidth = _u[1];
    var _v = React.useState(0), duration = _v[0], setDuration = _v[1];
    var _w = React.useState(false), isMounted = _w[0], setIsMounted = _w[1];
    var containerRef = React.useRef(null);
    var marqueeRef = React.useRef(null);
    var calculateWidth = function () {
        // Find width of container and width of marquee
        if (marqueeRef.current && containerRef.current) {
            setContainerWidth(containerRef.current.getBoundingClientRect().width);
            setMarqueeWidth(marqueeRef.current.getBoundingClientRect().width);
        }
        if (marqueeWidth < containerWidth) {
            setDuration(containerWidth / speed);
        }
        else {
            setDuration(marqueeWidth / speed);
        }
    };
    React.useEffect(function () {
        calculateWidth();
        // Rerender on window resize
        window.addEventListener("resize", calculateWidth);
        return function () {
            window.removeEventListener("resize", calculateWidth);
        };
    });
    React.useEffect(function () {
        setIsMounted(true);
    }, []);
    // Gradient color in an unfinished rgba format
    var rgbaGradientColor = "rgba(" + gradientColor[0] + ", " + gradientColor[1] + ", " + gradientColor[2];
    return (React__default['default'].createElement(React.Fragment, null, !isMounted ? null : (React__default['default'].createElement("div", { ref: containerRef, style: __assign(__assign({}, style), (_b = {}, _b["--pause-on-hover"] = pauseOnHover ? "paused" : "running", _b["--pause-on-click"] = pauseOnClick ? "paused" : "running", _b)), className: className + " marquee-container" },
        gradient && (React__default['default'].createElement("div", { style: (_c = {},
                _c["--gradient-color"] = rgbaGradientColor + ", 1), " + rgbaGradientColor + ", 0)",
                _c["--gradient-width"] = typeof gradientWidth === "number"
                    ? gradientWidth + "px"
                    : gradientWidth,
                _c), className: "overlay" })),
        React__default['default'].createElement("div", { ref: marqueeRef, style: (_d = {},
                _d["--play"] = play ? "running" : "paused",
                _d["--direction"] = direction === "left" ? "normal" : "reverse",
                _d["--duration"] = duration + "s",
                _d["--delay"] = delay + "s",
                _d["--iteration-count"] = !!loop ? "" + loop : "infinite",
                _d), className: "marquee", onAnimationIteration: onCycleComplete, onAnimationEnd: onFinish }, children),
        React__default['default'].createElement("div", { style: (_e = {},
                _e["--play"] = play ? "running" : "paused",
                _e["--direction"] = direction === "left" ? "normal" : "reverse",
                _e["--duration"] = duration + "s",
                _e["--delay"] = delay + "s",
                _e["--iteration-count"] = !!loop ? "" + loop : "infinite",
                _e), className: "marquee" }, children)))));
};

exports.Z = Marquee;
//# sourceMappingURL=index.js.map


/***/ })

}]);